<template>
    <div>
        <van-nav-bar :title="$route.query.name" @click-left="onClickLeft" left-arrow />
        <!-- <div id="modelShow"></div> -->
        <div id="MyViewerDiv"></div>
    </div>
</template>
<script>
export default {
    name: "",
    data() {
        return {
            data: null,
        }
    },
    methods: {
        viewers(url) {
            var _this = this;
            //初始化
            var config = {
                extensions: [
                    "Autodesk.Viewing.ZoomWindow",
                    // "Autodesk.Viewing.Collaboration",
                ],
                disabledExtensions: {
                    measure: false,
                    section: false,
                },
                memory: {
                    limit: 32 * 1024, //32 GB
                },
            };
            var myViewerDiv = document.getElementById("MyViewerDiv");
            _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
                myViewerDiv,
                config
            );
            var options = {
                document: url,
                language: "zh-HANS",
                env: "Local",
                offline: "true",
                useADP: false,
            };
            Autodesk.Viewing.Initializer(options, function onInitialized() {
                _this.viewer.start();
                _this.viewer.loadModel(options.document, {
                    isAEC: true,
                });
                _this.viewer.setTheme("light-theme");
                _this.viewer.addEventListener(
                    Autodesk.Viewing.TEXTURES_LOADED_EVENT,
                    function (event) {
                        //选择集
                        var json = Params.state.replace(/'/g, '"');
                        var jsonObject = JSON.parse(json);
                        _this.viewer.restoreState(jsonObject);
                    }
                );
            });
        },
        onClickLeft() {
            this.$router.go(-1);
        },
    },
    mounted() {
        this.data = this.$route.query.item;
        this.viewers(this.$store.state.baseUrl + this.data.pjdr11);
    },
}
</script>
<style lang="scss" scoped>
#MyViewerDiv {
    height: 100vh;
    width: 100%;
    position: absolute;
}
</style>
